import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import config from '@adc/configment'
import { Provider } from 'react-redux'
import { datadogRum } from '@datadog/browser-rum'
import logger from '@adc/logger'
import analytics from '@adc/analytics'
import {
  ApplicationContextProvider,
  ANNOUNCEMENT_DISMISS_COOKIE_KEY,
} from '@adc/ui-adc'
import * as blueprint from '@adc/blueprint'
import configureStore from '../common/store'
import App from '../common/components/app'
import '@adc/ui-adc/lib/styles.css'

/*
 * Analytics is initialized here so GTM can get started sooner
 * The init call is kept in our usual app/analytics location
 * This call will check if each analytics script has already loaded
 */
const store = configureStore(window.INITIAL_STATE.shellState)

const featureFlags = window.INITIAL_STATE.shellState.featureFlags

analytics.init(
  window.CONFIGS,
  analytics.createAnalyticsContext(window.INITIAL_STATE.shellState)
)
// TODO: This can go into the ApplicationShell in the toolkit once we have settled on the proper abstraction
// we feel is suitable
if (featureFlags['fe.resi.enable-datadog-rum-session-replay']) {
  logger.info('RUM session replay enabled')
  datadogRum.startSessionReplayRecording()
}

const readCookie = name => {
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
  return match ? decodeURIComponent(match.split('=')[1]) : undefined
}

hydrateRoot(
  window.ROOT_DOM_MOUNT,
  <ApplicationContextProvider
    graphWebsocket={new blueprint.primitives.GraphWebsocket()}
    featureFlags={featureFlags}
  >
    <Provider store={store}>
      <BrowserRouter basename={config.get('URL_BASE_PREFIX')}>
        <App
          ssrHints={{
            announcementDismissedFingerprint: readCookie(
              ANNOUNCEMENT_DISMISS_COOKIE_KEY
            ),
          }}
        />
      </BrowserRouter>
    </Provider>
  </ApplicationContextProvider>
)
